export enum ShippingTypeEnum {
  LOSS_SPREADSHEET = "LOSS_SPREADSHEET",
  RANKINGS_SPREADSHEET = "RANKINGS_SPREADSHEET",
  HR_EMAIL = "HR_EMAIL",
}

export enum DeliveryStatusEnum {
  DELIVERED = "DELIVERED",
  FAILED = "FAILED",
  HARD_BOUNCE = "HARD_BOUNCE",
}
